import lightFormat from 'date-fns/lightFormat';
import { SUTOCHNO_DATE_FORMAT, SUTOCHNO_URL } from '../../constants/sutochnoPilot';
import { IDateRange } from '../../types/dateRange';
import { IGuests } from '../../types/filters';

interface IGenerateSutochnoUrlParams {
  geoSearch: string;
  departureDates: IDateRange;
  guests: IGuests;
}

export function generateSutochnoUrl(params: IGenerateSutochnoUrlParams): string {
  const { geoSearch, departureDates, guests } = params;
  const { adults, children } = guests;
  const { from, to } = departureDates;

  const geoSearchParam = geoSearch ? `term=${encodeURIComponent(geoSearch)}` : null;
  const occupiedParam = from && to ? `occupied=${generateOccupiedValue(from, to)}` : null;
  const adultsParam = adults ? `guests_adults=${adults}` : null;
  const childrenParam = children ? `guests_childrens=${generateChildrenValue(children)}` : null;
  const utmMarks = ['utm_source=cian', 'utm_medium=mainpage_desktop', 'utm_campaign=sutochno'];

  const query = [geoSearchParam, occupiedParam, adultsParam, childrenParam, ...utmMarks].filter(Boolean).join('&');

  return `${SUTOCHNO_URL}search?${query}`;
}

function generateOccupiedValue(from: Date, to: Date): string {
  const dateFrom = lightFormat(from, SUTOCHNO_DATE_FORMAT);
  const dateTo = lightFormat(to, SUTOCHNO_DATE_FORMAT);

  return `${dateFrom};${dateTo}`;
}

const CHILDREN_AGE = 10;

/**
 * Возвращает строку вида "10,10,10", где каждое число - это возраст ребенка,
 * количество чисел равно количеству детей
 */
function generateChildrenValue(children: number): string {
  return Array.from({ length: children })
    .map(() => CHILDREN_AGE)
    .join(',');
}
